<div class="container py-4">
    <div class="progress-tracker">

        @for(step of steps; track step.key; let i = $index) {
        <div class="step" [ngClass]="{
  'completed': membershipStatus === 'Active'
    ? i <= currentStepIndex
    : i < currentStepIndex,
  'current': membershipStatus !== 'Active' && i === currentStepIndex,
  'rejected': step.key === 'PaymentRejected' && membershipStatus === 'PaymentRejected'
}">

            <div class="step-icon">
                <i [ngClass]="
  membershipStatus === 'Active'
    ? (i <= currentStepIndex ? 'bi bi-check2' : 'bi bi-circle')
    : i < currentStepIndex
    ? 'bi bi-check2'
    : i === currentStepIndex
    ? 'bi bi-hourglass-split'
    : 'bi bi-circle'
">
                </i>
            </div>

            <div class="step-text">
                <div class="step-title">{{ step.label }}</div>
            </div>

        </div>
        }

    </div>
</div>